<template>
  <div class="tree-view--wrap">
    <v-treeview
      :items="items"
      item-key="id"
      density="compact"
      indent-lines
      separate-roots
      :item-children="item => item.children?.length ? item.children : undefined"
    >
      <template #toggle="{ props: toggleProps, item }">
        <v-btn
          v-bind="toggleProps"
          :aria-label="getAriaLabelForItem(item)"
        />
      </template>

      <template #title="{ item }">
        <template v-if="categoryHasPage(item) || item.externalLink">
          <a
            v-if="item.externalLink"
            :href="item.externalLink"
            target="_blank"
            rel="noopener"
          >
            {{ item.title }}
          </a>
          <router-link v-else :to="item.path">
            {{ item.title }}
          </router-link>
        </template>

        <span v-else>
          {{ item.title }}
        </span>
      </template>
    </v-treeview>
  </div>
</template>

<script>
import pages from '@/preload/data/pages.json'
import brandProductsPage from '@/preload/data/brandProductsPage.json'
import { getBlogCategory } from '@/utils/blog.js'

export default {
  name: 'tree-view',

  props: {
    items: {
      type: Array,
      default: () => ([]),
    },

    hideExternalLinks: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    /**
     * @param {object} category
     * @returns {boolean}
     */
    categoryHasPage (category) {
      return [...pages, brandProductsPage].some(({ path }) => path === category.path) ||
        getBlogCategory()?.path === category.path
    },

    getAriaLabelForItem (item) {
      return item.children && item.children.length > 0
        ? `Seiten in der Rubrik '${item.title}' anzeigen`
        : item.title
    },
  },
}
</script>

<style scoped lang="scss">
  a {
    color: rgba(0, 0, 0, 0.87);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
</style>
